<block-ui>
    <div class="row">
        <!-- FIDEICOMISO -->
        <div class="col-6" *ngIf="ActiveTemplateKey === 'FIDEICOMISO'">
            <ngb-accordion [closeOthers]="true" activeIds="static-1">
                <ngb-panel id="static-1" [formGroup]="FideicomisoCesionarioForm">
                        <ng-template ngbPanelHeader>
                            <div class="d-flex justify-content-between">
                                <button class="btn btn-link text-start" ngbPanelToggle>Fideicomiente Cesionario</button>
                                <select class="form-control form-control-sm col-4 mt-1" formControlName="bac.Genero_fideicomitente_cesionario" (change)="CargarTSECesionario()">
                                    <option value="" selected>Género</option>
                                    <option *ngFor="let Gender of GendersType | keyvalue" [value]="Gender.key">
                                        {{Gender.value}}
                                    </option>
                                </select>
                            </div>
                        </ng-template>
                        <ng-template ngbPanelContent>
                            <div class="form-group row">
                                <div class="col-sm">
                                    <select class="form-control form-control-sm" formControlName="bac.tipo_identificacion_Fideicomitente_Cesionario" (change)="SelectCardType($event.target.getAttribute('formControlName'))">
                                    <label>Tipo de identificación:</label>
                                        <option *ngFor="let Tipo of TiposIdentificacion" [value]="Tipo">{{Tipo}}</option>
                                    </select>
                                    <small class="text-muted">
                                        bac.tipo_identificacion_Fideicomitente_Cesionario
                                    </small>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-sm">
                                    <label>Cédula:</label>
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="bac.cedula_Firmante_Fideicomitente_Cesionario"
                                        (change)="CargarTSECesionario()">
                                    <small class="text-muted">
                                        bac.cedula_Firmante_Fideicomitente_Cesionario
                                    </small>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-sm">
                                    <label>Nombre:</label>
                                    <input [readonly]="VerifySupervisorPermission(FideicomisoCesionarioForm, 'bac.tipo_identificacion_Fideicomitente_Cesionario')" type="text" class="form-control form-control-sm"
                                        formControlName="tse.nombre_Firmante_Fideicomitente_Cesionario">
                                    <small class="text-muted">
                                        tse.nombre_Firmante_Fideicomitente_Cesionario
                                    </small>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-sm">
                                    <label>Nacionalidad:</label>
                                    <input [readonly]="VerifySupervisorPermission(FideicomisoCesionarioForm, 'bac.tipo_identificacion_Fideicomitente_Cesionario')" type="text" class="form-control form-control-sm"
                                        formControlName="tse.nacionalidad_Firmante_Fideicomitente_Cesionario">
                                    <small class="text-muted">
                                        tse.nacionalidad_Firmante_Fideicomitente_Cesionario
                                    </small>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-sm">
                                    <label>Estado Civil:</label>
                                    <div class="input-group">
                                        <input [readonly]="VerifySupervisorPermission(FideicomisoCesionarioForm, 'bac.tipo_identificacion_Fideicomitente_Cesionario')" type="text" class="form-control form-control-sm"
                                            formControlName="tse.estadocivil_Firmante_Fideicomitente_Cesionario">
                                        <select class="form-control form-control-sm" formControlName="bac.cantidad_estadosciviles_Fideicomitente_Cesionario">
                                            <option *ngFor="let Cantidad of CantidadEstadosCiviles" [value]="Cantidad">{{Cantidad}}</option>
                                        </select>
                                    </div>
                                    <small class="text-muted">
                                        tse.estadocivil_Firmante_Fideicomitente_Cesionario
                                    </small>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-sm">
                                    <label>Profesión:</label>
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="bac.profesion_Firmante_Fideicomitente_Cesionario">
                                    <small class="text-muted">
                                        bac.profesion_Firmante_Fideicomitente_Cesionario
                                    </small>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-sm">
                                    <label>Domicilio:</label>
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="bac.domicilio_Firmante_Fideicomitente_Cesionario">
                                    <small class="text-muted">
                                        bac.domicilio_Firmante_Fideicomitente_Cesionario
                                    </small>
                                </div>
                            </div>
                        </ng-template>
                </ngb-panel>
                <ngb-panel id="static-2" [formGroup]="FideicomisoDeudorForm">
                    <ng-template ngbPanelHeader>
                        <div class="d-flex justify-content-between">
                            <button class="btn btn-link text-start" ngbPanelToggle>Deudor</button>
                            <select class="form-control form-control-sm col-4 mt-1" formControlName="bac.Genero_deudor" (change)="CargarTSEDeudor()">
                                <option value="" selected>Género</option>
                                <option *ngFor="let Gender of GendersType | keyvalue" [value]="Gender.key">
                                    {{Gender.value}}
                                </option>
                            </select>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cédula:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.cedula_deudor"
                                    (change)="CargarTSEDeudor()">
                                <small class="text-muted">
                                    bac.cedula_deudor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nombre:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nombre_deudor">
                                <small class="text-muted">
                                    tse.nombre_deudor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nacionalidad:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nacionalidad_deudor">
                                <small class="text-muted">
                                    tse.nacionalidad_deudor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Estado Civil:</label>
                                <div class="input-group">
                                    <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                        formControlName="tse.estadocivil_deudor">
                                    <select class="form-control form-control-sm" formControlName="bac.cantidad_estadosciviles_deudor">
                                        <option *ngFor="let Cantidad of CantidadEstadosCiviles" [value]="Cantidad">{{Cantidad}}</option>
                                    </select>
                                </div>
                                <small class="text-muted">
                                    tse.estadocivil_deudor
                                </small>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="static-3" [formGroup]="FideicomisoOriginalForm">
                    <ng-template ngbPanelHeader>
                        <div class="d-flex justify-content-between">
                            <button class="btn btn-link text-start" ngbPanelToggle>Fideicomiente Original</button>
                            <select class="form-control form-control-sm col-4 mt-1" formControlName="bac.Genero_fideicomitente_original" (change)="CargarTSEOriginal()">
                                <option value="" selected>Género</option>
                                <option *ngFor="let Gender of GendersType | keyvalue" [value]="Gender.key">
                                    {{Gender.value}}
                                </option>
                            </select>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Tipo de identificación:</label>
                                <select class="form-control form-control-sm" formControlName="bac.tipo_identificacion_Fideicomitente_Original" (change)="SelectCardType($event.target.getAttribute('formControlName'))">
                                    <option *ngFor="let Tipo of TiposIdentificacion" [value]="Tipo">{{Tipo}}</option>
                                </select>
                                <small class="text-muted">
                                    bac.tipo_identificacion_Fideicomitente_Original
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cédula:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.cedula_Fideicomitente_Original"
                                    (change)="CargarTSEOriginal()">
                                <small class="text-muted">
                                    bac.cedula_Fideicomitente_Original
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nombre:</label>
                                <input [readonly]="VerifySupervisorPermission(FideicomisoOriginalForm, 'bac.tipo_identificacion_Fideicomitente_Original')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nombre_Firmante_Fideicomitente_Original">
                                <small class="text-muted">
                                    tse.nombre_Firmante_Fideicomitente_Original
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nacionalidad:</label>
                                <input [readonly]="VerifySupervisorPermission(FideicomisoOriginalForm, 'bac.tipo_identificacion_Fideicomitente_Original')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nacionalidad_Firmante_Fideicomitente_Original">
                                <small class="text-muted">
                                    tse.nacionalidad_Firmante_Fideicomitente_Original
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Estado Civil:</label>
                                <div class="input-group">
                                    <input [readonly]="VerifySupervisorPermission(FideicomisoOriginalForm, 'bac.tipo_identificacion_Fideicomitente_Original')" type="text" class="form-control form-control-sm"
                                        formControlName="tse.estadocivil_Firmante_Fideicomitente_Original">
                                    <select class="form-control form-control-sm" formControlName="bac.cantidad_estadosciviles_Fideicomitente_Original">
                                        <option *ngFor="let Cantidad of CantidadEstadosCiviles" [value]="Cantidad">{{Cantidad}}</option>
                                    </select>
                                </div>
                                <small class="text-muted">
                                    tse.estadocivil_Firmante_Fideicomitente_Original
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Profesión:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.profesion_Fideicomitente_Original">
                                <small class="text-muted">
                                    bac.profesion_Fideicomitente_Original
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Domicilio:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.domicilio_Fideicomitente_Original">
                                <small class="text-muted">
                                    bac.domicilio_Fideicomitente_Original
                                </small>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="static-4" [formGroup]="FideicomisoSociedadForm">
                    <ng-template ngbPanelHeader>
                        <div class="d-flex justify-content-between">
                            <button class="btn btn-link text-start" ngbPanelToggle>Sociedad Fideicomiente Original</button>
                            <select class="form-control form-control-sm col-4 mt-1" formControlName="bac.Genero_apoderado_fideicomitente_original" (change)="CargarTSEApoderadoOriginal()">
                                <option value="" selected>Género</option>
                                <option *ngFor="let Gender of GendersType | keyvalue" [value]="Gender.key">
                                    {{Gender.value}}
                                </option>
                            </select>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cédula Jurídica:</label>
                                <div class="input-group">
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="bac.cedula_Sociedad_Fideicomitente_Original_Tipo"
                                        placeholder="Tipo" (change)="CargarRNSociedad()">
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="bac.cedula_Sociedad_Fideicomitente_Original_Clase"
                                        placeholder="Clase" (change)="CargarRNSociedad()">
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="bac.cedula_Sociedad_Fideicomitente_Original_Consecutivo"
                                        placeholder="Consecutivo" (change)="CargarRNSociedad()">
                                </div>
                                <small class="text-muted">
                                    bac.cedula_Sociedad_Fideicomitente_Original
                                </small>
                                <input hidden type="text"
                                    formControlName="bac.cedula_Sociedad_Fideicomitente_Original">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Razón Social:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.razon_Social_Sociedad_Fideicomitente_Original">
                                <small class="text-muted">
                                    rnp.razon_Social_Sociedad_Fideicomitente_Original
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Domicilio:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.domicilio_Sociedad_Fideicomitente_Original">
                                <small class="text-muted">
                                    bac.domicilio_Sociedad_Fideicomitente_Original
                                </small>
                            </div>
                        </div>
                        <hr/>
                        <h5>Apoderado</h5>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Tipo de identificación:</label>
                                <select class="form-control form-control-sm" formControlName="bac.Tipo_identificacion_apoderado_fideicomitente_original" (change)="SelectCardType($event.target.getAttribute('formControlName'))">
                                    <option *ngFor="let Tipo of TiposIdentificacion" [value]="Tipo">{{Tipo}}</option>
                                </select>
                                <small class="text-muted">
                                    bac.Tipo_identificacion_apoderado_fideicomitente_original
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cédula:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.cedula_apoderado_fideicomitente_original"
                                    (change)="CargarTSEApoderadoOriginal()">
                                <small class="text-muted">
                                    bac.cedula_apoderado_fideicomitente_original
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nombre:</label>
                                <input [readonly]="VerifySupervisorPermission(FideicomisoSociedadForm, 'bac.Tipo_identificacion_apoderado_fideicomitente_original')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nombre_apoderado_fideicomitente_original">
                                <small class="text-muted">
                                    tse.nombre_apoderado_fideicomitente_original
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nacionalidad:</label>
                                <input [readonly]="VerifySupervisorPermission(FideicomisoSociedadForm, 'bac.Tipo_identificacion_apoderado_fideicomitente_original')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nacionalidad_apoderado_fideicomitente_original">
                                <small class="text-muted">
                                    tse.nacionalidad_apoderado_fideicomitente_original
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Estado Civil:</label>
                                <div class="input-group">
                                    <input [readonly]="VerifySupervisorPermission(FideicomisoSociedadForm, 'bac.Tipo_identificacion_apoderado_fideicomitente_original')" type="text" class="form-control form-control-sm"
                                        formControlName="tse.estadocivil_apoderado_fideicomitente_original">
                                    <select class="form-control form-control-sm" formControlName="bac.cantidad_estadocivil_apoderado_fideicomitente_original">
                                        <option *ngFor="let Cantidad of CantidadEstadosCiviles" [value]="Cantidad">{{Cantidad}}</option>
                                    </select>
                                </div>
                                <small class="text-muted">
                                    tse.estadocivil_apoderado_fideicomitente_original
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Profesión:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.profesion_apoderado_fideicomitente_Original">
                                <small class="text-muted">
                                    bac.profesion_apoderado_fideicomitente_Original
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Domicilio:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.domicilio_apoderado_fideicomitente_original">
                                <small class="text-muted">
                                    bac.domicilio_apoderado_fideicomitente_original
                                </small>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="static-5" [formGroup]="FideicomisoGeneralForm" title="Datos Generales">
                    <ng-template ngbPanelContent>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Moneda:</label>
                                <select class="form-control form-control-sm" formControlName="bac.moneda">
                                    <option value="" hidden selected>Seleccione una moneda</option>
                                    <option *ngFor="let Moneda of Monedas" [value]="Moneda">{{Moneda}}</option>
                                </select>
                                <small class="text-muted">
                                    bac.moneda
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Suma préstamo:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.suma_Prestamo"
                                    (change)="FormatNumber(FideicomisoGeneralForm, $event.target.getAttribute('formControlName'))"
                                    appTwoDigitDecimaNumber>
                                <small class="text-muted">
                                    bac.suma_Prestamo
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cuota inicial préstamo:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.cuota_Inicial_Prestamo"
                                    (change)="FormatNumber(FideicomisoGeneralForm, $event.target.getAttribute('formControlName'))"
                                    appTwoDigitDecimaNumber>
                                <small class="text-muted">
                                    bac.cuota_Inicial_Prestamo
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Plazo meses préstamo</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.plazo_Meses_Prestamo"
                                    (change)="FormatNumber(FideicomisoGeneralForm, $event.target.getAttribute('formControlName'));CalculateDueDateFideicomiso();"
                                    appTwoDigitDecimaNumber>
                                <small class="text-muted">
                                    bac.plazo_Meses_Prestamo
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Fecha inicio prestamo:</label>
                                <input type="date" class="form-control form-control-sm"
                                    formControlName="bac.fecha_Inicio_Prestamo"
                                    (change)="CalculateDueDateFideicomiso()">
                                <small class="text-muted">
                                    bac.fecha_Inicio_Prestamo
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Fecha pago primer cuota préstamo:</label>
                                <input type="date" class="form-control form-control-sm"
                                    formControlName="bac.fecha_Pago_Primer_Cuota_Prestamo">
                                <small class="text-muted">
                                    bac.fecha_Pago_Primer_Cuota_Prestamo
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Fecha vencimiento préstamo:</label>
                                <input type="date" class="form-control form-control-sm"
                                    formControlName="bac.fecha_Vencimiento_Prestamo">
                                <small class="text-muted">
                                    bac.fecha_Vencimiento_Prestamo
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Tasa fija préstamo:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.tasa_Fija_Prestamo"
                                    (change)="FormatNumber(FideicomisoGeneralForm, $event.target.getAttribute('formControlName'))"
                                    appTwoDigitDecimaNumber>
                                <small class="text-muted">
                                    bac.tasa_Fija_Prestamo
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Tasa variable préstamo:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.tasa_Variable_Prestamo"
                                    (change)="FormatNumber(FideicomisoGeneralForm, $event.target.getAttribute('formControlName'))"
                                    appTwoDigitDecimaNumber>
                                <small class="text-muted">
                                    bac.tasa_Variable_Prestamo
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Tasa piso préstamo:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.tasa_Piso_Prestamo"
                                    (change)="FormatNumber(FideicomisoGeneralForm, $event.target.getAttribute('formControlName'))"
                                    appTwoDigitDecimaNumber>
                                <small class="text-muted">
                                    bac.tasa_Piso_Prestamo
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Tasa comisión bancaria:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.tasa_comision_bancaria"
                                    (change)="FormatNumber(FideicomisoGeneralForm, $event.target.getAttribute('formControlName'))"
                                    appTwoDigitDecimaNumber>
                                <small class="text-muted">
                                    bac.tasa_comision_bancaria
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <div class="form-group form-check">
                                    <input type="checkbox" class="form-check-input"
                                        id="bac.clausula_Construccion"
                                        formControlName="bac.clausula_Construccion">
                                    <label for="bac.clausula_Construccion" class="form-check-label"> Cláusula construcción</label>
                                </div>
                                <small class="text-muted">
                                    bac.clausula_Construccion
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label class=""> Cláusula séptima</label>
                                <div class="form-group form-check">
                                    <input type="radio" class="form-check-input" 
                                        name="bac.clausula_Septima" 
                                        id="bac.clausula_primera_quincena" 
                                        formControlName="bac.clausula_Septima" 
                                        value="primera">
                                    <label for="bac.clausula_primera_quincena" class="form-check-label"> Primera quincena</label>
                                </div>
                                <div class="form-group form-check">
                                    <input type="radio" class="form-check-input" 
                                        name="bac.clausula_Septima"
                                        id="bac.clausula_segunda_quincena" 
                                        formControlName="bac.clausula_Septima"
                                        value="segunda">
                                    <label for="bac.clausula_segunda_quincena" class="form-check-label"> Segunda quincena</label>
                                </div>
                                <small class="text-muted">
                                    bac.clausula_Septima
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <div class="form-group form-check">
                                    <input type="checkbox" class="form-check-input"
                                        id="bac.clausula_comision_prepago"
                                        formControlName="bac.clausula_comision_prepago">
                                    <label for="bac.clausula_comision_prepago" class="form-check-label"> Cláusula comisión prepago</label>
                                </div>
                                <small class="text-muted">
                                    bac.clausula_comision_prepago
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <div class="form-group form-check">
                                    <input type="checkbox" class="form-check-input"
                                        id="bac.clausula_aseguradora"
                                        formControlName="bac.clausula_aseguradora">
                                    <label for="bac.clausula_aseguradora" class="form-check-label"> Cláusula aseguradoras</label>
                                </div>
                                <small class="text-muted">
                                    bac.clausula_aseguradora
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nombre fideicomiso:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.nombre_Fideicomiso">
                                <small class="text-muted">
                                    bac.nombre_Fideicomiso
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Valor estimado finca:</label>
                                <div class="input-group">
                                    <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.valor_Estimado_Finca"
                                    (change)="FormatNumber(FideicomisoGeneralForm, $event.target.getAttribute('formControlName'))"
                                    appTwoDigitDecimaNumber>
                                    <select class="form-control form-control-sm" formControlName="bac.valor_Moneda_Finca">
                                        <option value="" hidden selected>Seleccione una moneda</option>
                                        <option *ngFor="let Moneda of Monedas" [value]="Moneda">{{Moneda}}</option>
                                    </select>
                                </div>
                                <small class="text-muted">
                                    bac.valor_Estimado_Finca
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Tarifa mensual fiduciario:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.tarifa_Mensual_Fiduciario"
                                    (change)="FormatNumber(FideicomisoGeneralForm, $event.target.getAttribute('formControlName'))"
                                    appTwoDigitDecimaNumber>
                                <small class="text-muted">
                                    bac.tarifa_Mensual_Fiduciario
                                </small>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="static-6" [formGroup]="FideicomisoFincaForm" title="Datos de Finca">
                    <ng-template ngbPanelContent>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Folio Real:</label>
                                <div class="input-group">
                                    <select class="form-control form-control-sm"
                                        formControlName="bac.duplicado_Finca" (change)="CargarRNFinca()">
                                        <option value="" selected>Duplicado</option>
                                        <option *ngFor="let Duplicado of Duplicados" value="{{Duplicado}}">{{Duplicado}}
                                        </option>
                                    </select>
                                    <select class="form-control form-control-sm"
                                        formControlName="bac.horizontal_Finca" (change)="CargarRNFinca()">
                                        <option value="" selected>Horizontal</option>
                                        <option *ngFor="let Horizontal of Horizontales" value="{{Horizontal}}">
                                            {{Horizontal}}
                                        </option>
                                    </select>
                                    <input type="text" class="form-control form-control-sm" placeholder="Derecho"
                                        formControlName="bac.derecho_Finca" (change)="CargarRNFinca()">
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <div class="input-group">
                                    <select class="form-control form-control-sm"
                                        formControlName="bac.provincia_Finca" (change)="CargarRNFinca()">
                                        <option *ngFor="let Provincia of Provincias" value="{{Provincia.id}}">
                                            {{Provincia.value}}</option>
                                    </select>
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="bac.folio_Real_Finca" (change)="CargarRNFinca()">
                                </div>
                                <small class="text-muted">
                                    bac.folio_Real_Finca
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Distrito:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.distrito_Finca">
                                <small class="text-muted">
                                    rnp.distrito_Finca
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Canton:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.canton_Finca">
                                <small class="text-muted">
                                    rnp.canton_Finca
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Provincia:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.provincia_Finca">
                                <small class="text-muted">
                                    rnp.provincia_Finca
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Naturaleza:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.naturaleza_Finca">
                                <small class="text-muted">
                                    rnp.naturaleza_Finca
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Linderos:</label>
                                <textarea [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.linderos" rows="5"></textarea>
                                <small class="text-muted">
                                    rnp.linderos
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Metros cuadrados:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.metros_Cuadrados_Finca">
                                <small class="text-muted">
                                    rnp.metros_Cuadrados_Finca
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Plano catastro:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.plano_Catastro_Finca">
                                <small class="text-muted">
                                    rnp.plano_Catastro_Finca
                                </small>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="static-7" [formGroup]="FideicomisoFiduciariaForm" title="Sociedad Fiduciaria">
                    <ng-template ngbPanelContent>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cédula Jurídica:</label>
                                <div class="input-group">
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="bac.cedulajuridica_fiduciaria_Tipo"
                                        placeholder="Tipo" (change)="CargarRNFiduciaria()">
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="bac.cedulajuridica_fiduciaria_Clase"
                                        placeholder="Clase" (change)="CargarRNFiduciaria()">
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="bac.cedulajuridica_fiduciaria_Consecutivo"
                                        placeholder="Consecutivo" (change)="CargarRNFiduciaria()">
                                </div>
                                <small class="text-muted">
                                    bac.cedulajuridica_fiduciaria
                                </small>
                                <input hidden type="text"
                                    formControlName="bac.cedulajuridica_fiduciaria">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nombre o Razón Social:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.razon_Social_fiduciaria">
                                <small class="text-muted">
                                    rnp.razon_Social_fiduciaria
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Domicilio:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.domicilio_fiduciaria">
                                <small class="text-muted">
                                    bac.domicilio_fiduciaria
                                </small>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="static-8" [formGroup]="FideicomisoApoderadoForm">
                    <ng-template ngbPanelHeader>
                        <div class="d-flex justify-content-between">
                            <button class="btn btn-link text-start" ngbPanelToggle>Apoderado Fiduciaria</button>
                            <select class="form-control form-control-sm col-4 mt-1" formControlName="bac.Genero_apoderado_fiduciaria" (change)="CargarTSEApoderado()">
                                <option value="" selected>Género</option>
                                <option *ngFor="let Gender of GendersType | keyvalue" [value]="Gender.key">
                                    {{Gender.value}}
                                </option>
                            </select>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Tipo de identificación:</label>
                                <select class="form-control form-control-sm" formControlName="bac.Tipo_identificacion_apoderado_fiduciario" (change)="SelectCardType($event.target.getAttribute('formControlName'))">
                                    <option *ngFor="let Tipo of TiposIdentificacion" [value]="Tipo">{{Tipo}}</option>
                                </select>
                                <small class="text-muted">
                                    bac.Tipo_identificacion_apoderado_fiduciario
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cédula:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.cedula_apoderado_fiduciaria"
                                    (change)="CargarTSEApoderado()">
                                <small class="text-muted">
                                    bac.cedula_apoderado_fiduciaria
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nombre:</label>
                                <input [readonly]="VerifySupervisorPermission(FideicomisoApoderadoForm, 'bac.Tipo_identificacion_apoderado_fiduciario')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nombre_apoderado_fiduciaria">
                                <small class="text-muted">
                                    tse.nombre_apoderado_fiduciaria
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nacionalidad:</label>
                                <input [readonly]="VerifySupervisorPermission(FideicomisoApoderadoForm, 'bac.Tipo_identificacion_apoderado_fiduciario')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nacionalidad_apoderado_fiduciaria">
                                <small class="text-muted">
                                    tse.nacionalidad_apoderado_fiduciaria
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Estado Civil:</label>
                                <div class="input-group">
                                    <input [readonly]="VerifySupervisorPermission(FideicomisoApoderadoForm, 'bac.Tipo_identificacion_apoderado_fiduciario')" type="text" class="form-control form-control-sm"
                                        formControlName="tse.estadocivil_apoderado_fiduciaria">
                                    <select class="form-control form-control-sm" formControlName="bac.cantidad_estadosciviles_apoderado_fiduciaria">
                                        <option *ngFor="let Cantidad of CantidadEstadosCiviles" [value]="Cantidad">{{Cantidad}}</option>
                                    </select>
                                </div>
                                <small class="text-muted">
                                    tse.estadocivil_apoderado_fiduciaria
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Profesión:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.profesion_apoderado_fiduciaria">
                                <small class="text-muted">
                                    bac.profesion_apoderado_fiduciaria
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Domicilio:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.domicilio_apoderado_fiduciaria">
                                <small class="text-muted">
                                    bac.domicilio_apoderado_fiduciaria
                                </small>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>
        <!-- HIPOTECA -->
        <div class="col-6" *ngIf="ActiveTemplateKey === 'HIPOTECA'">
            <ngb-accordion [closeOthers]="true" activeIds="static-1">
                <ngb-panel id="static-1" [formGroup]="HipotecaDeudorForm">
                    <ng-template ngbPanelHeader>
                        <div class="d-flex justify-content-between">
                            <button class="btn btn-link text-start" ngbPanelToggle>Deudor</button>
                            <select class="form-control form-control-sm col-4 mt-1" formControlName="bac.Genero_deudor" (change)="CargarTSEHipotecaDeudor()">
                                <option value="" selected>Género</option>
                                <option *ngFor="let Gender of GendersType | keyvalue" [value]="Gender.key">
                                    {{Gender.value}}
                                </option>
                            </select>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="form-group row">
                            <div class="col-sm">
                                <select class="form-control form-control-sm" formControlName="bac.tipo_identificacion_deudor" (change)="SelectCardType($event.target.getAttribute('formControlName'))">
                                <label>Tipo de identificación:</label>
                                    <option *ngFor="let Tipo of TiposIdentificacion" [value]="Tipo">{{Tipo}}</option>
                                </select>
                                <small class="text-muted">
                                    bac.tipo_identificacion_deudor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cédula:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.cedula_deudor"
                                    (change)="CargarTSEHipotecaDeudor()">
                                <small class="text-muted">
                                    bac.cedula_deudor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nombre:</label>
                                <input [readonly]="VerifySupervisorPermission(HipotecaDeudorForm, 'bac.tipo_identificacion_deudor')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nombre_deudor">
                                <small class="text-muted">
                                    tse.nombre_deudor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nacionalidad:</label>
                                <input [readonly]="VerifySupervisorPermission(HipotecaDeudorForm, 'bac.tipo_identificacion_deudor')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nacionalidad_deudor">
                                <small class="text-muted">
                                    tse.nacionalidad_deudor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Estado Civil:</label>
                                <div class="input-group">
                                    <input [readonly]="VerifySupervisorPermission(HipotecaDeudorForm, 'bac.tipo_identificacion_deudor')" type="text" class="form-control form-control-sm"
                                        formControlName="tse.estadocivil_deudor">
                                    <select class="form-control form-control-sm" formControlName="bac.cantidad_estadosciviles_deudor">
                                        <option *ngFor="let Cantidad of CantidadEstadosCiviles" [value]="Cantidad">{{Cantidad}}</option>
                                    </select>
                                </div>
                                <small class="text-muted">
                                    tse.estadocivil_deudor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Profesión:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.profesion_deudor">
                                <small class="text-muted">
                                    bac.profesion_deudor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Domicilio:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.domicilio_deudor">
                                <small class="text-muted">
                                    bac.domicilio_deudor
                                </small>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="static-2" [formGroup]="HipotecaGeneralForm" title="Datos Generales">
                    <ng-template ngbPanelContent>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Monto crédito:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.monto_credito"
                                    (change)="FormatNumber(HipotecaGeneralForm, $event.target.getAttribute('formControlName'))"
                                    appTwoDigitDecimaNumber>
                                <small class="text-muted">
                                    bac.monto_credito
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cuotas:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.cuotas"
                                    (change)="FormatNumber(HipotecaGeneralForm, $event.target.getAttribute('formControlName'))"
                                    appTwoDigitDecimaNumber>
                                <small class="text-muted">
                                    bac.cuotas
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Meses</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.meses"
                                    (change)="FormatNumber(HipotecaGeneralForm, $event.target.getAttribute('formControlName'));CalculateDueDateHipoteca()"
                                    appTwoDigitDecimaNumber>
                                <small class="text-muted">
                                    bac.meses
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Fecha inicio prestamo:</label>
                                <input type="date" class="form-control form-control-sm"
                                    formControlName="bac.fecha_Inicio_Prestamo"
                                    (change)="CalculateDueDateHipoteca()">
                                <small class="text-muted">
                                    bac.fecha_Inicio_Prestamo
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Fecha pago primer cuota préstamo:</label>
                                <input type="date" class="form-control form-control-sm"
                                    formControlName="bac.fecha_Pago_Primer_Cuota_Prestamo">
                                <small class="text-muted">
                                    bac.fecha_Pago_Primer_Cuota_Prestamo
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Fecha vencimiento préstamo:</label>
                                <input type="date" class="form-control form-control-sm"
                                    formControlName="bac.fecha_Vencimiento_Prestamo">
                                <small class="text-muted">
                                    bac.fecha_Vencimiento_Prestamo
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Tasa fija:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.tasafija"
                                    (change)="FormatNumber(HipotecaGeneralForm, $event.target.getAttribute('formControlName'))"
                                    appTwoDigitDecimaNumber>
                                <small class="text-muted">
                                    bac.tasafija
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Tasa variable prestamo:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.tasa_Variable_Prestamo"
                                    (change)="FormatNumber(HipotecaGeneralForm, $event.target.getAttribute('formControlName'))"
                                    appTwoDigitDecimaNumber>
                                <small class="text-muted">
                                    bac.tasa_Variable_Prestamo 
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Tasa piso prestamo:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.tasa_Piso_Prestamo"
                                    (change)="FormatNumber(HipotecaGeneralForm, $event.target.getAttribute('formControlName'))"
                                    appTwoDigitDecimaNumber>
                                <small class="text-muted">
                                    bac.tasa_Piso_Prestamo
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Comisión:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.comision"
                                    (change)="FormatNumber(HipotecaGeneralForm, $event.target.getAttribute('formControlName'))"
                                    appTwoDigitDecimaNumber>
                                <small class="text-muted">
                                    bac.comision
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nombre persona asegurada:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.nombre_persona_asegurada">
                                <small class="text-muted">
                                    bac.nombre_persona_asegurada
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <div class="form-group form-check">
                                    <input type="checkbox" class="form-check-input"
                                        id="bac.clausula_Construccion"
                                        formControlName="bac.clausula_Construccion">
                                    <label for="bac.clausula_Construccion" class="form-check-label"> Cláusula construcción</label>
                                </div>
                                <small class="text-muted">
                                    bac.clausula_Construccion
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <div class="form-group form-check">
                                    <input type="checkbox" class="form-check-input"
                                        id="bac.clausula_aseguradora"
                                        formControlName="bac.clausula_aseguradora">
                                    <label for="bac.clausula_aseguradora" class="form-check-label"> Cláusula aseguradoras</label>
                                </div>
                                <small class="text-muted">
                                    bac.clausula_aseguradora
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <div class="form-group form-check">
                                    <input type="checkbox" class="form-check-input"
                                        id="bac.traspaso_indirecta"
                                        formControlName="bac.traspaso_indirecta">
                                    <label for="bac.traspaso_indirecta" class="form-check-label"> Traspaso de indirecta</label>
                                </div>
                                <small class="text-muted">
                                    bac.traspaso_indirecta
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label class=""> Cláusula séptima</label>
                                <div class="form-group form-check">
                                    <input type="radio" class="form-check-input" 
                                        name="bac.clausula_Septima" 
                                        id="bac.clausula_primera_quincena" 
                                        formControlName="bac.clausula_Septima" 
                                        value="primera">
                                    <label for="bac.clausula_primera_quincena" class="form-check-label"> Primera quincena</label>
                                </div>
                                <div class="form-group form-check">
                                    <input type="radio" class="form-check-input" 
                                        name="bac.clausula_Septima"
                                        id="bac.clausula_segunda_quincena" 
                                        formControlName="bac.clausula_Septima"
                                        value="segunda">
                                    <label for="bac.clausula_segunda_quincena" class="form-check-label"> Segunda quincena</label>
                                </div>
                                <small class="text-muted">
                                    bac.clausula_Septima
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label class=""> Cláusula comisión prepago</label>
                                <div class="form-group form-check">
                                    <input type="radio" class="form-check-input" 
                                        name="bac.clausula_comision_prepago" 
                                        id="bac.clausula_comision_prepago_corriente" 
                                        formControlName="bac.clausula_comision_prepago" 
                                        value="corriente">
                                    <label for="bac.clausula_comision_prepago_corriente" class="form-check-label"> Hipoteca corriente</label>
                                </div>
                                <div class="form-group form-check">
                                    <input type="radio" class="form-check-input" 
                                        name="bac.clausula_comision_prepago"
                                        id="bac.clausula_comision_prepago_switching" 
                                        formControlName="bac.clausula_comision_prepago"
                                        value="switching">
                                    <label for="bac.clausula_comision_prepago_switching" class="form-check-label"> Hipoteca switching</label>
                                </div>
                                <small class="text-muted">
                                    bac.clausula_comision_prepago
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Grado de hipoteca:</label>
                                <select class="form-control form-control-sm" formControlName="bac.grado_hipoteca">
                                    <option value="" hidden selected>Seleccione un grado</option>
                                    <option *ngFor="let Grado of GradosHipoteca" [value]="Grado">{{Grado}}</option>
                                </select>
                                <small class="text-muted">
                                    bac.grado_hipoteca
                                </small>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="static-3" [formGroup]="HipotecaPropietarioForm">
                    <ng-template ngbPanelHeader>
                        <div class="d-flex justify-content-between">
                            <button class="btn btn-link text-start" ngbPanelToggle>Propietario Registral</button>
                            <select class="form-control form-control-sm col-4 mt-1" formControlName="bac.Genero_propietario_registral" (change)="CargarTSEHipotecaPropietario()">
                                <option value="" selected>Género</option>
                                <option *ngFor="let Gender of GendersType | keyvalue" [value]="Gender.key">
                                    {{Gender.value}}
                                </option>
                            </select>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="form-group row">
                            <div class="col-sm">
                                <select class="form-control form-control-sm" formControlName="bac.tipo_identificacion_propietario" (change)="SelectCardType($event.target.getAttribute('formControlName'))">
                                <label>Tipo de identificación:</label>
                                    <option *ngFor="let Tipo of TiposIdentificacion" [value]="Tipo">{{Tipo}}</option>
                                </select>
                                <small class="text-muted">
                                    bac.tipo_identificacion_propietario
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cédula:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.cedula_propietario_registral"
                                    (change)="CargarTSEHipotecaPropietario()">
                                <small class="text-muted">
                                    bac.cedula_propietario_registral
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nombre:</label>
                                <input [readonly]="VerifySupervisorPermission(HipotecaPropietarioForm, 'bac.tipo_identificacion_propietario')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nombre_propietario_registral">
                                <small class="text-muted">
                                    tse.nombre_propietario_registral
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nacionalidad:</label>
                                <input [readonly]="VerifySupervisorPermission(HipotecaPropietarioForm, 'bac.tipo_identificacion_propietario')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nacionalidad_propietario_registral">
                                <small class="text-muted">
                                    tse.nacionalidad_propietario_registral
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Estado Civil:</label>
                                <div class="input-group">
                                    <input [readonly]="VerifySupervisorPermission(HipotecaPropietarioForm, 'bac.tipo_identificacion_propietario')" type="text" class="form-control form-control-sm"
                                        formControlName="tse.estadocivil_propietario_registral">
                                    <select class="form-control form-control-sm" formControlName="bac.cantidad_estadosciviles_propietario_registral">
                                        <option *ngFor="let Cantidad of CantidadEstadosCiviles" [value]="Cantidad">{{Cantidad}}</option>
                                    </select>
                                </div>
                                <small class="text-muted">
                                    tse.estadocivil_propietario_registral
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Profesión:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.profesion_propietario_registral">
                                <small class="text-muted">
                                    bac.profesion_propietario_registral
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Domicilio:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.domicilio_propietario_registral">
                                <small class="text-muted">
                                    bac.domicilio_propietario_registral
                                </small>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="static-4" [formGroup]="HipotecaSociedadForm">
                    <ng-template ngbPanelHeader>
                        <div class="d-flex justify-content-between">
                            <button class="btn btn-link text-start" ngbPanelToggle>Sociedad Propietario Registral</button>
                            <select class="form-control form-control-sm col-4 mt-1" formControlName="bac.Genero_apoderado_Propietario" (change)="CargarTSEApoderadoPropietario()">
                                <option value="" selected>Género</option>
                                <option *ngFor="let Gender of GendersType | keyvalue" [value]="Gender.key">
                                    {{Gender.value}}
                                </option>
                            </select>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cédula Jurídica:</label>
                                <div class="input-group">
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="bac.cedula_Sociedad_Propietario_Tipo"
                                        placeholder="Tipo" (change)="CargarRNSociedadPropietario()">
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="bac.cedula_Sociedad_Propietario_Clase"
                                        placeholder="Clase" (change)="CargarRNSociedadPropietario()">
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="bac.cedula_Sociedad_Propietario_Consecutivo"
                                        placeholder="Consecutivo" (change)="CargarRNSociedadPropietario()">
                                </div>
                                <small class="text-muted">
                                    bac.cedula_Sociedad_Propietario
                                </small>
                                <input hidden type="text"
                                    formControlName="bac.cedula_Sociedad_Propietario">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Razón Social:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.razon_Social_Sociedad_Propietario">
                                <small class="text-muted">
                                    rnp.razon_Social_Sociedad_Propietario
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Domicilio:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.domicilio_Sociedad_Propietario">
                                <small class="text-muted">
                                    bac.domicilio_Sociedad_Propietario
                                </small>
                            </div>
                        </div>
                        <hr/>
                        <h5>Apoderado</h5>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Tipo de identificación:</label>
                                <select class="form-control form-control-sm" formControlName="bac.Tipo_identificacion_apoderado_Propietario" (change)="SelectCardType($event.target.getAttribute('formControlName'))">
                                    <option *ngFor="let Tipo of TiposIdentificacion" [value]="Tipo">{{Tipo}}</option>
                                </select>
                                <small class="text-muted">
                                    bac.Tipo_identificacion_apoderado_Propietario
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cédula:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.cedula_apoderado_Propietario"
                                    (change)="CargarTSEApoderadoPropietario()">
                                <small class="text-muted">
                                    bac.cedula_apoderado_Propietario
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nombre:</label>
                                <input [readonly]="VerifySupervisorPermission(HipotecaSociedadForm, 'bac.Tipo_identificacion_apoderado_Propietario')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nombre_apoderado_Propietario">
                                <small class="text-muted">
                                    tse.nombre_apoderado_Propietario
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nacionalidad:</label>
                                <input [readonly]="VerifySupervisorPermission(HipotecaSociedadForm, 'bac.Tipo_identificacion_apoderado_Propietario')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nacionalidad_apoderado_Propietario">
                                <small class="text-muted">
                                    tse.nacionalidad_apoderado_Propietario
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Estado Civil:</label>
                                <div class="input-group">
                                    <input [readonly]="VerifySupervisorPermission(HipotecaSociedadForm, 'bac.Tipo_identificacion_apoderado_Propietario')" type="text" class="form-control form-control-sm"
                                        formControlName="tse.estadocivil_apoderado_Propietario">
                                    <select class="form-control form-control-sm" formControlName="bac.cantidad_estadosciviles_apoderado_Propietario">
                                        <option *ngFor="let Cantidad of CantidadEstadosCiviles" [value]="Cantidad">{{Cantidad}}</option>
                                    </select>
                                </div>
                                <small class="text-muted">
                                    tse.estadocivil_apoderado_Propietario
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Profesión:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.profesion_apoderado_Propietario">
                                <small class="text-muted">
                                    bac.profesion_apoderado_Propietario
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Domicilio:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.domicilio_apoderado_Propietario">
                                <small class="text-muted">
                                    bac.domicilio_apoderado_Propietario
                                </small>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="static-5" [formGroup]="HipotecaFincaForm" title="Datos de Finca">
                    <ng-template ngbPanelContent>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Folio Real:</label>
                                <div class="input-group">
                                    <select class="form-control form-control-sm"
                                        formControlName="bac.duplicado_Finca" (change)="CargarRNHipotecaFinca()">
                                        <option value="" selected>Duplicado</option>
                                        <option *ngFor="let Duplicado of Duplicados" value="{{Duplicado}}">{{Duplicado}}
                                        </option>
                                    </select>
                                    <select class="form-control form-control-sm"
                                        formControlName="bac.horizontal_Finca" (change)="CargarRNHipotecaFinca()">
                                        <option value="" selected>Horizontal</option>
                                        <option *ngFor="let Horizontal of Horizontales" value="{{Horizontal}}">
                                            {{Horizontal}}
                                        </option>
                                    </select>
                                    <input type="text" class="form-control form-control-sm" placeholder="Derecho"
                                        formControlName="bac.derecho_Finca" (change)="CargarRNHipotecaFinca()">
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <div class="input-group">
                                    <select class="form-control form-control-sm"
                                        formControlName="bac.provincia_Finca" (change)="CargarRNHipotecaFinca()">
                                        <option *ngFor="let Provincia of Provincias" value="{{Provincia.id}}">
                                            {{Provincia.value}}
                                        </option>
                                    </select>
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="bac.folio_Real_Finca" (change)="CargarRNHipotecaFinca()">
                                </div>
                                <small class="text-muted">
                                    bac.folio_Real_Finca
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Distrito:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.distrito_Finca">
                                <small class="text-muted">
                                    rnp.distrito_Finca
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Canton:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.canton_Finca">
                                <small class="text-muted">
                                    rnp.canton_Finca
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Provincia:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.provincia_Finca">
                                <small class="text-muted">
                                    rnp.provincia_Finca
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Naturaleza:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.naturaleza_Finca">
                                <small class="text-muted">
                                    rnp.naturaleza_Finca
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Linderos:</label>
                                <textarea [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.linderos" rows="5"></textarea>
                                <small class="text-muted">
                                    rnp.linderos
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Metros cuadrados:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.metros_Cuadrados_Finca">
                                <small class="text-muted">
                                    rnp.metros_Cuadrados_Finca
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Plano catastro:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.plano_Catastro_Finca">
                                <small class="text-muted">
                                    rnp.plano_Catastro_Finca
                                </small>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>
        <!-- PRENDAS -->
        <div class="col-6" *ngIf="ActiveTemplateKey === 'PRENDAS'">
            <ngb-accordion [closeOthers]="true" activeIds="static-1">
                <ngb-panel id="static-1" [formGroup]="PrendasDeudorForm">
                    <ng-template ngbPanelHeader>
                        <div class="d-flex justify-content-between">
                            <button class="btn btn-link text-start" ngbPanelToggle>Deudor</button>
                            <select class="form-control form-control-sm col-4 mt-1" formControlName="bac.Genero_deudor" (change)="CargarTSEPrendasDeudor()">
                                <option value="" selected>Género</option>
                                <option *ngFor="let Gender of GendersType | keyvalue" [value]="Gender.key">
                                    {{Gender.value}}
                                </option>
                            </select>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="form-group row">
                            <div class="col-sm">
                                <select class="form-control form-control-sm" formControlName="bac.tipo_identificacion_deudor" (change)="SelectCardType($event.target.getAttribute('formControlName'))">
                                <label>Tipo de identificación:</label>
                                    <option *ngFor="let Tipo of TiposIdentificacion" [value]="Tipo">{{Tipo}}</option>
                                </select>
                                <small class="text-muted">
                                    bac.tipo_identificacion_deudor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cédula:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.cedula_deudor"
                                    (change)="CargarTSEPrendasDeudor()">
                                <small class="text-muted">
                                    bac.cedula_deudor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nombre:</label>
                                <input [readonly]="VerifySupervisorPermission(PrendasDeudorForm, 'bac.tipo_identificacion_deudor')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nombre_deudor">
                                <small class="text-muted">
                                    tse.nombre_deudor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nacionalidad:</label>
                                <input [readonly]="VerifySupervisorPermission(PrendasDeudorForm, 'bac.tipo_identificacion_deudor')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nacionalidad_deudor">
                                <small class="text-muted">
                                    tse.nacionalidad_deudor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Estado Civil:</label>
                                <div class="input-group">
                                    <input [readonly]="VerifySupervisorPermission(PrendasDeudorForm, 'bac.tipo_identificacion_deudor')" type="text" class="form-control form-control-sm"
                                        formControlName="tse.estadocivil_deudor">
                                    <select class="form-control form-control-sm" formControlName="bac.cantidad_estadosciviles_deudor">
                                        <option *ngFor="let Cantidad of CantidadEstadosCiviles" [value]="Cantidad">{{Cantidad}}</option>
                                    </select>
                                </div>
                                <small class="text-muted">
                                    tse.estadocivil_deudor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Profesión:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.profesion_deudor">
                                <small class="text-muted">
                                    bac.profesion_deudor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Domicilio:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.domicilio_deudor">
                                <small class="text-muted">
                                    bac.domicilio_deudor
                                </small>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="static-2" [formGroup]="PrendasSociedadDeudorForm">
                    <ng-template ngbPanelHeader>
                        <div class="d-flex justify-content-between">
                            <button class="btn btn-link text-start" ngbPanelToggle>Sociedad Deudor</button>
                            <select class="form-control form-control-sm col-4 mt-1" formControlName="bac.Genero_sociedad_deudor">
                                <option value="" selected>Género</option>
                                <option *ngFor="let Gender of GendersType | keyvalue" [value]="Gender.key">
                                    {{Gender.value}}
                                </option>
                            </select>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cédula Jurídica:</label>
                                <div class="input-group">
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="bac.cedula_Sociedad_Deudor_Tipo"
                                        placeholder="Tipo" (change)="CargarRNPrendasSociedadDeudor()">
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="bac.cedula_Sociedad_Deudor_Clase"
                                        placeholder="Clase" (change)="CargarRNPrendasSociedadDeudor()">
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="bac.cedula_Sociedad_Deudor_Consecutivo"
                                        placeholder="Consecutivo" (change)="CargarRNPrendasSociedadDeudor()">
                                </div>
                                <small class="text-muted">
                                    bac.cedula_Sociedad_Deudor
                                </small>
                                <input hidden type="text"
                                    formControlName="bac.cedula_Sociedad_Deudor">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Razón Social:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.razon_Social_Sociedad_Deudor">
                                <small class="text-muted">
                                    rnp.razon_Social_Sociedad_Deudor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Domicilio:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.domicilio_Sociedad_Deudor">
                                <small class="text-muted">
                                    bac.domicilio_Sociedad_Deudor
                                </small>
                            </div>
                        </div>
                        <hr/>
                        <div class="d-flex justify-content-between mb-3 row">
                            <h5 class="col text-start">Apoderado</h5>
                            <div class="col-4">
                                <select class="form-control form-control-sm" formControlName="bac.Genero_apoderado_deudor" (change)="CargarTSEPrendasApoderadoDeudor()">
                                    <option value="" selected>Género</option>
                                    <option *ngFor="let Gender of GendersType | keyvalue" [value]="Gender.key">
                                        {{Gender.value}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Tipo de identificación:</label>
                                <select class="form-control form-control-sm" formControlName="bac.Tipo_identificacion_apoderado_Deudor" (change)="SelectCardType($event.target.getAttribute('formControlName'))">
                                    <option *ngFor="let Tipo of TiposIdentificacion" [value]="Tipo">{{Tipo}}</option>
                                </select>
                                <small class="text-muted">
                                    bac.Tipo_identificacion_apoderado_Deudor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cédula:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.cedula_apoderado_Deudor"
                                    (change)="CargarTSEPrendasApoderadoDeudor()">
                                <small class="text-muted">
                                    bac.cedula_apoderado_Deudor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nombre:</label>
                                <input [readonly]="VerifySupervisorPermission(PrendasSociedadDeudorForm, 'bac.Tipo_identificacion_apoderado_Deudor')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nombre_apoderado_Deudor">
                                <small class="text-muted">
                                    tse.nombre_apoderado_Deudor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nacionalidad:</label>
                                <input [readonly]="VerifySupervisorPermission(PrendasSociedadDeudorForm, 'bac.Tipo_identificacion_apoderado_Deudor')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nacionalidad_apoderado_Deudor">
                                <small class="text-muted">
                                    tse.nacionalidad_apoderado_Deudor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Estado Civil:</label>
                                <div class="input-group">
                                    <input [readonly]="VerifySupervisorPermission(PrendasSociedadDeudorForm, 'bac.Tipo_identificacion_apoderado_Deudor')" type="text" class="form-control form-control-sm"
                                        formControlName="tse.estadocivil_apoderado_Deudor">
                                    <select class="form-control form-control-sm" formControlName="bac.cantidad_estadosciviles_apoderado_Deudor">
                                        <option *ngFor="let Cantidad of CantidadEstadosCiviles" [value]="Cantidad">{{Cantidad}}</option>
                                    </select>
                                </div>
                                <small class="text-muted">
                                    tse.estadocivil_apoderado_Deudor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Profesión:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.profesion_apoderado_Deudor">
                                <small class="text-muted">
                                    bac.profesion_apoderado_Deudor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Domicilio:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.domicilio_apoderado_Deudor">
                                <small class="text-muted">
                                    bac.domicilio_apoderado_Deudor
                                </small>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="static-3" [formGroup]="PrendasVendedorForm">
                    <ng-template ngbPanelHeader>
                        <div class="d-flex justify-content-between">
                            <button class="btn btn-link text-start" ngbPanelToggle>Vendedor</button>
                            <select class="form-control form-control-sm col-4 mt-1" formControlName="bac.Genero_vendedor" (change)="CargarTSEPrendasVendedor()">
                                <option value="" selected>Género</option>
                                <option *ngFor="let Gender of GendersType | keyvalue" [value]="Gender.key">
                                    {{Gender.value}}
                                </option>
                            </select>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="form-group row">
                            <div class="col-sm">
                                <select class="form-control form-control-sm" formControlName="bac.tipo_identificacion_vendedor" (change)="SelectCardType($event.target.getAttribute('formControlName'))">
                                <label>Tipo de identificación:</label>
                                    <option *ngFor="let Tipo of TiposIdentificacion" [value]="Tipo">{{Tipo}}</option>
                                </select>
                                <small class="text-muted">
                                    bac.tipo_identificacion_vendedor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cédula:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.cedula_vendedor"
                                    (change)="CargarTSEPrendasVendedor()">
                                <small class="text-muted">
                                    bac.cedula_vendedor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nombre:</label>
                                <input [readonly]="VerifySupervisorPermission(PrendasVendedorForm, 'bac.tipo_identificacion_vendedor')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nombre_vendedor">
                                <small class="text-muted">
                                    tse.nombre_vendedor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nacionalidad:</label>
                                <input [readonly]="VerifySupervisorPermission(PrendasVendedorForm, 'bac.tipo_identificacion_vendedor')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nacionalidad_vendedor">
                                <small class="text-muted">
                                    tse.nacionalidad_vendedor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Estado Civil:</label>
                                <div class="input-group">
                                    <input [readonly]="VerifySupervisorPermission(PrendasVendedorForm, 'bac.tipo_identificacion_vendedor')" type="text" class="form-control form-control-sm"
                                        formControlName="tse.estadocivil_vendedor">
                                    <select class="form-control form-control-sm" formControlName="bac.cantidad_estadosciviles_vendedor">
                                        <option *ngFor="let Cantidad of CantidadEstadosCiviles" [value]="Cantidad">{{Cantidad}}</option>
                                    </select>
                                </div>
                                <small class="text-muted">
                                    tse.estadocivil_vendedor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Profesión:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.profesion_vendedor">
                                <small class="text-muted">
                                    bac.profesion_vendedor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Domicilio:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.domicilio_vendedor">
                                <small class="text-muted">
                                    bac.domicilio_vendedor
                                </small>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="static-4" [formGroup]="PrendasSociedadVendedorForm">
                    <ng-template ngbPanelHeader>
                        <div class="d-flex justify-content-between">
                            <button class="btn btn-link text-start" ngbPanelToggle>Sociedad Vendedor</button>
                            <select class="form-control form-control-sm col-4 mt-1" formControlName="bac.Genero_sociedad_vendedor">
                                <option value="" selected>Género</option>
                                <option *ngFor="let Gender of GendersType | keyvalue" [value]="Gender.key">
                                    {{Gender.value}}
                                </option>
                            </select>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cédula Jurídica:</label>
                                <div class="input-group">
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="bac.cedula_Sociedad_Vendedor_Tipo"
                                        placeholder="Tipo" (change)="CargarRNPrendasSociedadVendedor()">
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="bac.cedula_Sociedad_Vendedor_Clase"
                                        placeholder="Clase" (change)="CargarRNPrendasSociedadVendedor()">
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="bac.cedula_Sociedad_Vendedor_Consecutivo"
                                        placeholder="Consecutivo" (change)="CargarRNPrendasSociedadVendedor()">
                                </div>
                                <small class="text-muted">
                                    bac.cedula_Sociedad_Vendedor
                                </small>
                                <input hidden type="text"
                                    formControlName="bac.cedula_Sociedad_Vendedor">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Razón Social:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.razon_Social_Sociedad_Vendedor">
                                <small class="text-muted">
                                    rnp.razon_Social_Sociedad_Vendedor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Domicilio:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.domicilio_Sociedad_Vendedor">
                                <small class="text-muted">
                                    bac.domicilio_Sociedad_Vendedor
                                </small>
                            </div>
                        </div>
                        <hr/>
                        <div class="d-flex justify-content-between mb-3 row">
                            <h5 class="col text-start">Apoderado</h5>
                            <div class="col-4">
                                <select class="form-control form-control-sm" formControlName="bac.Genero_apoderado_vendedor" (change)="CargarTSEPrendasApoderadoVendedor()">
                                    <option value="" selected>Género</option>
                                    <option *ngFor="let Gender of GendersType | keyvalue" [value]="Gender.key">
                                        {{Gender.value}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Tipo de identificación:</label>
                                <select class="form-control form-control-sm" formControlName="bac.Tipo_identificacion_apoderado_Vendedor" (change)="SelectCardType($event.target.getAttribute('formControlName'))">
                                    <option *ngFor="let Tipo of TiposIdentificacion" [value]="Tipo">{{Tipo}}</option>
                                </select>
                                <small class="text-muted">
                                    bac.Tipo_identificacion_apoderado_Vendedor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cédula:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.cedula_apoderado_Vendedor"
                                    (change)="CargarTSEPrendasApoderadoVendedor()">
                                <small class="text-muted">
                                    bac.cedula_apoderado_Vendedor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nombre:</label>
                                <input [readonly]="VerifySupervisorPermission(PrendasSociedadVendedorForm, 'bac.Tipo_identificacion_apoderado_Vendedor')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nombre_apoderado_Vendedor">
                                <small class="text-muted">
                                    tse.nombre_apoderado_Vendedor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nacionalidad:</label>
                                <input [readonly]="VerifySupervisorPermission(PrendasSociedadVendedorForm, 'bac.Tipo_identificacion_apoderado_Vendedor')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nacionalidad_apoderado_Vendedor">
                                <small class="text-muted">
                                    tse.nacionalidad_apoderado_Vendedor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Estado Civil:</label>
                                <div class="input-group">
                                    <input [readonly]="VerifySupervisorPermission(PrendasSociedadVendedorForm, 'bac.Tipo_identificacion_apoderado_Vendedor')" type="text" class="form-control form-control-sm"
                                        formControlName="tse.estadocivil_apoderado_Vendedor">
                                    <select class="form-control form-control-sm" formControlName="bac.cantidad_estadosciviles_apoderado_Vendedor">
                                        <option *ngFor="let Cantidad of CantidadEstadosCiviles" [value]="Cantidad">{{Cantidad}}</option>
                                    </select>
                                </div>
                                <small class="text-muted">
                                    tse.estadocivil_apoderado_Vendedor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Profesión:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.profesion_apoderado_Vendedor">
                                <small class="text-muted">
                                    bac.profesion_apoderado_Vendedor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Domicilio:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.domicilio_apoderado_Vendedor">
                                <small class="text-muted">
                                    bac.domicilio_apoderado_Vendedor
                                </small>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="static-5" [formGroup]="PrendasCompradorForm">
                    <ng-template ngbPanelHeader>
                        <div class="d-flex justify-content-between">
                            <button class="btn btn-link text-start" ngbPanelToggle>Comprador</button>
                            <select class="form-control form-control-sm col-4 mt-1" formControlName="bac.Genero_Comprador" (change)="CargarTSEPrendasComprador()">
                                <option value="" selected>Género</option>
                                <option *ngFor="let Gender of GendersType | keyvalue" [value]="Gender.key">
                                    {{Gender.value}}
                                </option>
                            </select>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="form-group row">
                            <div class="col-sm">
                                <select class="form-control form-control-sm" formControlName="bac.tipo_identificacion_Comprador" (change)="SelectCardType($event.target.getAttribute('formControlName'))">
                                <label>Tipo de identificación:</label>
                                    <option *ngFor="let Tipo of TiposIdentificacion" [value]="Tipo">{{Tipo}}</option>
                                </select>
                                <small class="text-muted">
                                    bac.tipo_identificacion_Comprador
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cédula:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.cedula_Comprador"
                                    (change)="CargarTSEPrendasComprador()">
                                <small class="text-muted">
                                    bac.cedula_Comprador
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nombre:</label>
                                <input [readonly]="VerifySupervisorPermission(PrendasCompradorForm, 'bac.tipo_identificacion_Comprador')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nombre_Comprador">
                                <small class="text-muted">
                                    tse.nombre_Comprador
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nacionalidad:</label>
                                <input [readonly]="VerifySupervisorPermission(PrendasCompradorForm, 'bac.tipo_identificacion_Comprador')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nacionalidad_Comprador">
                                <small class="text-muted">
                                    tse.nacionalidad_Comprador
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Estado Civil:</label>
                                <div class="input-group">
                                    <input [readonly]="VerifySupervisorPermission(PrendasCompradorForm, 'bac.tipo_identificacion_Comprador')" type="text" class="form-control form-control-sm"
                                        formControlName="tse.estadocivil_Comprador">
                                    <select class="form-control form-control-sm" formControlName="bac.cantidad_estadosciviles_Comprador">
                                        <option *ngFor="let Cantidad of CantidadEstadosCiviles" [value]="Cantidad">{{Cantidad}}</option>
                                    </select>
                                </div>
                                <small class="text-muted">
                                    tse.estadocivil_Comprador
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Profesión:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.profesion_Comprador">
                                <small class="text-muted">
                                    bac.profesion_Comprador
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Domicilio:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.domicilio_Comprador">
                                <small class="text-muted">
                                    bac.domicilio_Comprador
                                </small>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="static-6" [formGroup]="PrendasSociedadCompradorForm">
                    <ng-template ngbPanelHeader>
                        <div class="d-flex justify-content-between">
                            <button class="btn btn-link text-start" ngbPanelToggle>Sociedad Comprador</button>
                            <select class="form-control form-control-sm col-4 mt-1" formControlName="bac.Genero_sociedad_comprador">
                                <option value="" selected>Género</option>
                                <option *ngFor="let Gender of GendersType | keyvalue" [value]="Gender.key">
                                    {{Gender.value}}
                                </option>
                            </select>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cédula Jurídica:</label>
                                <div class="input-group">
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="bac.cedula_Sociedad_Comprador_Tipo"
                                        placeholder="Tipo" (change)="CargarRNPrendasSociedadComprador()">
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="bac.cedula_Sociedad_Comprador_Clase"
                                        placeholder="Clase" (change)="CargarRNPrendasSociedadComprador()">
                                    <input type="text" class="form-control form-control-sm"
                                        formControlName="bac.cedula_Sociedad_Comprador_Consecutivo"
                                        placeholder="Consecutivo" (change)="CargarRNPrendasSociedadComprador()">
                                </div>
                                <small class="text-muted">
                                    bac.cedula_Sociedad_Comprador
                                </small>
                                <input hidden type="text"
                                    formControlName="bac.cedula_Sociedad_Comprador">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Razón Social:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.razon_Social_Sociedad_Comprador">
                                <small class="text-muted">
                                    rnp.razon_Social_Sociedad_Comprador
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Domicilio:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.domicilio_Sociedad_Comprador">
                                <small class="text-muted">
                                    bac.domicilio_Sociedad_Comprador
                                </small>
                            </div>
                        </div>
                        <hr/>
                        <div class="d-flex justify-content-between mb-3 row">
                            <h5 class="col text-start">Apoderado</h5>
                            <div class="col-4">
                                <select class="form-control form-control-sm" formControlName="bac.Genero_apoderado_comprador" (change)="CargarTSEPrendasApoderadoComprador()">
                                    <option value="" selected>Género</option>
                                    <option *ngFor="let Gender of GendersType | keyvalue" [value]="Gender.key">
                                        {{Gender.value}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Tipo de identificación:</label>
                                <select class="form-control form-control-sm" formControlName="bac.Tipo_identificacion_apoderado_Comprador" (change)="SelectCardType($event.target.getAttribute('formControlName'))">
                                    <option *ngFor="let Tipo of TiposIdentificacion" [value]="Tipo">{{Tipo}}</option>
                                </select>
                                <small class="text-muted">
                                    bac.Tipo_identificacion_apoderado_Comprador
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cédula:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.cedula_apoderado_Comprador"
                                    (change)="CargarTSEPrendasApoderadoComprador()">
                                <small class="text-muted">
                                    bac.cedula_apoderado_Comprador
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nombre:</label>
                                <input [readonly]="VerifySupervisorPermission(PrendasSociedadCompradorForm, 'bac.Tipo_identificacion_apoderado_Comprador')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nombre_apoderado_Comprador">
                                <small class="text-muted">
                                    tse.nombre_apoderado_Comprador
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nacionalidad:</label>
                                <input [readonly]="VerifySupervisorPermission(PrendasSociedadCompradorForm, 'bac.Tipo_identificacion_apoderado_Comprador')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nacionalidad_apoderado_Comprador">
                                <small class="text-muted">
                                    tse.nacionalidad_apoderado_Comprador
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Estado Civil:</label>
                                <div class="input-group">
                                    <input [readonly]="VerifySupervisorPermission(PrendasSociedadCompradorForm, 'bac.Tipo_identificacion_apoderado_Comprador')" type="text" class="form-control form-control-sm"
                                        formControlName="tse.estadocivil_apoderado_Comprador">
                                    <select class="form-control form-control-sm" formControlName="bac.cantidad_estadosciviles_apoderado_Comprador">
                                        <option *ngFor="let Cantidad of CantidadEstadosCiviles" [value]="Cantidad">{{Cantidad}}</option>
                                    </select>
                                </div>
                                <small class="text-muted">
                                    tse.estadocivil_apoderado_Comprador
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Profesión:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.profesion_apoderado_Comprador">
                                <small class="text-muted">
                                    bac.profesion_apoderado_Comprador
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Domicilio:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.domicilio_apoderado_Comprador">
                                <small class="text-muted">
                                    bac.domicilio_apoderado_Comprador
                                </small>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="static-7" [formGroup]="PrendasFiadorForm">
                    <ng-template ngbPanelHeader>
                        <div class="d-flex justify-content-between">
                            <button class="btn btn-link text-start" ngbPanelToggle>Fiador</button>
                            <select class="form-control form-control-sm col-4 mt-1" formControlName="bac.Genero_Fiador" (change)="CargarTSEPrendasFiador()">
                                <option value="" selected>Género</option>
                                <option *ngFor="let Gender of GendersType | keyvalue" [value]="Gender.key">
                                    {{Gender.value}}
                                </option>
                            </select>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="form-group row">
                            <div class="col-sm">
                                <select class="form-control form-control-sm" formControlName="bac.tipo_identificacion_Fiador" (change)="SelectCardType($event.target.getAttribute('formControlName'))">
                                <label>Tipo de identificación:</label>
                                    <option *ngFor="let Tipo of TiposIdentificacion" [value]="Tipo">{{Tipo}}</option>
                                </select>
                                <small class="text-muted">
                                    bac.tipo_identificacion_Fiador
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cédula:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.cedula_Fiador"
                                    (change)="CargarTSEPrendasFiador()">
                                <small class="text-muted">
                                    bac.cedula_Fiador
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nombre:</label>
                                <input [readonly]="VerifySupervisorPermission(PrendasFiadorForm, 'bac.tipo_identificacion_Fiador')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nombre_Fiador">
                                <small class="text-muted">
                                    tse.nombre_Fiador
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nacionalidad:</label>
                                <input [readonly]="VerifySupervisorPermission(PrendasFiadorForm, 'bac.tipo_identificacion_Fiador')" type="text" class="form-control form-control-sm"
                                    formControlName="tse.nacionalidad_Fiador">
                                <small class="text-muted">
                                    tse.nacionalidad_Fiador
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Estado Civil:</label>
                                <div class="input-group">
                                    <input [readonly]="VerifySupervisorPermission(PrendasFiadorForm, 'bac.tipo_identificacion_Fiador')" type="text" class="form-control form-control-sm"
                                        formControlName="tse.estadocivil_Fiador">
                                    <select class="form-control form-control-sm" formControlName="bac.cantidad_estadosciviles_Fiador">
                                        <option *ngFor="let Cantidad of CantidadEstadosCiviles" [value]="Cantidad">{{Cantidad}}</option>
                                    </select>
                                </div>
                                <small class="text-muted">
                                    tse.estadocivil_Fiador
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Profesión:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.profesion_Fiador">
                                <small class="text-muted">
                                    bac.profesion_Fiador
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Domicilio:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.domicilio_Fiador">
                                <small class="text-muted">
                                    bac.domicilio_Fiador
                                </small>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="static-8" [formGroup]="PrendasGeneralForm" title="Datos Generales">
                    <ng-template ngbPanelContent>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nombre prenda:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.nombre_Prenda">
                                <small class="text-muted">
                                    bac.nombre_Prenda
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Monto prima:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.monto_prima">
                                <small class="text-muted">
                                    bac.monto_prima
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Banco vendedor:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.banco_vendedor">
                                <small class="text-muted">
                                    bac.banco_vendedor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cuenta vendedor:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.cuenta_vendedor">
                                <small class="text-muted">
                                    bac.cuenta_vendedor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Origen fondos:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.origen_fondos">
                                <small class="text-muted">
                                    bac.origen_fondos
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Banco comprador:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.banco_comprador">
                                <small class="text-muted">
                                    bac.banco_comprador
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cuenta comprador:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.cuenta_comprador">
                                <small class="text-muted">
                                    bac.cuenta_comprador
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Monto crédito:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.monto_credito"
                                    (change)="FormatNumber(PrendasGeneralForm, $event.target.getAttribute('formControlName'))"
                                    appTwoDigitDecimaNumber>
                                <small class="text-muted">
                                    bac.monto_credito
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cuotas:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.cuotas"
                                    (change)="FormatNumber(PrendasGeneralForm, $event.target.getAttribute('formControlName'))"
                                    appTwoDigitDecimaNumber>
                                <small class="text-muted">
                                    bac.cuotas
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Meses</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.meses"
                                    (change)="FormatNumber(PrendasGeneralForm, $event.target.getAttribute('formControlName'));CalculateDueDatePrendas()"
                                    appTwoDigitDecimaNumber>
                                <small class="text-muted">
                                    bac.meses
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Fecha de Inicio:</label>
                                <input type="date" class="form-control form-control-sm"
                                    formControlName="bac.fecha_Inicio_Prenda"
                                    (change)="CalculateDueDatePrendas()">
                                <small class="text-muted">
                                    bac.fecha_Inicio_Prenda
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Fecha de Primer cuota:</label>
                                <input type="date" class="form-control form-control-sm"
                                    formControlName="bac.fecha_Pago_Primer_Cuota_Prenda">
                                <small class="text-muted">
                                    bac.fecha_Pago_Primer_Cuota_Prenda
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Fecha de vencimiento:</label>
                                <input type="date" class="form-control form-control-sm"
                                    formControlName="bac.fecha_Vencimiento_Prenda">
                                <small class="text-muted">
                                    bac.fecha_Vencimiento_Prenda
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Plazo tasa fija:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.plazo_tasafija">
                                <small class="text-muted">
                                    bac.plazo_tasafija
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Tasa fija:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.tasafija"
                                    (change)="FormatNumber(PrendasGeneralForm, $event.target.getAttribute('formControlName'))"
                                    appTwoDigitDecimaNumber>
                                <small class="text-muted">
                                    bac.tasafija
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Tasa variable prestamo:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.tasa_Variable_Prestamo"
                                    (change)="FormatNumber(PrendasGeneralForm, $event.target.getAttribute('formControlName'))"
                                    appTwoDigitDecimaNumber>
                                <small class="text-muted">
                                    bac.tasa_Variable_Prestamo 
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Tasa piso prestamo:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.tasa_Piso_Prestamo"
                                    (change)="FormatNumber(PrendasGeneralForm, $event.target.getAttribute('formControlName'))"
                                    appTwoDigitDecimaNumber>
                                <small class="text-muted">
                                    bac.tasa_Piso_Prestamo
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Comisión:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.comision"
                                    (change)="FormatNumber(PrendasGeneralForm, $event.target.getAttribute('formControlName'))"
                                    appTwoDigitDecimaNumber>
                                <small class="text-muted">
                                    bac.comision
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Grado de prenda:</label>
                                <select class="form-control form-control-sm" formControlName="bac.grado_prenda">
                                    <option value="" hidden selected>Seleccione un grado</option>
                                    <option *ngFor="let Grado of GradosHipoteca" [value]="Grado">{{Grado}}</option>
                                </select>
                                <small class="text-muted">
                                    bac.grado_prenda
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Fecha de Firma:</label>
                                <input type="date" class="form-control form-control-sm"
                                    formControlName="bac.fecha_firma">
                                <small class="text-muted">
                                    bac.fecha_firma
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <div class="form-group form-check">
                                    <input type="checkbox" class="form-check-input"
                                        id="bac.compra_venta"
                                        formControlName="bac.compra_venta">
                                    <label for="bac.compra_venta" class="form-check-label">Compra y venta</label>
                                </div>
                                <small class="text-muted">
                                    bac.compra_venta
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <div class="form-group form-check">
                                    <input type="checkbox" class="form-check-input"
                                        id="bac.Comision_Bancaria"
                                        formControlName="bac.Comision_Bancaria">
                                    <label for="bac.Comision_Bancaria" class="form-check-label">Comisión bancaria</label>
                                </div>
                                <small class="text-muted">
                                    bac.Comision_Bancaria
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <div class="form-group form-check">
                                    <input type="checkbox" class="form-check-input"
                                        id="bac.Pasivos"
                                        formControlName="bac.Pasivos">
                                    <label for="bac.Pasivos" class="form-check-label">Pasivos</label>
                                </div>
                                <small class="text-muted">
                                    bac.Pasivos
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <div class="form-group form-check">
                                    <input type="checkbox" class="form-check-input"
                                        id="bac.check_Tasa_Variable"
                                        formControlName="bac.check_Tasa_Variable">
                                    <label for="bac.check_Tasa_Variable" class="form-check-label">Tasa variable</label>
                                </div>
                                <small class="text-muted">
                                    bac.check_Tasa_Variable
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <div class="form-group form-check">
                                    <input type="checkbox" class="form-check-input"
                                        id="bac.check_fiador"
                                        formControlName="bac.check_fiador">
                                    <label for="bac.check_fiador" class="form-check-label">Lleva fiador</label>
                                </div>
                                <small class="text-muted">
                                    bac.check_fiador
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <div class="form-group form-check">
                                    <input type="checkbox" class="form-check-input"
                                        id="bac.consentimiento"
                                        formControlName="bac.consentimiento">
                                    <label for="bac.consentimiento" class="form-check-label">Consentimiento</label>
                                </div>
                                <small class="text-muted">
                                    bac.consentimiento
                                </small>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
                <ngb-panel id="static-9" [formGroup]="PrendasVehiculoForm" title="Datos de vehículo">
                    <ng-template ngbPanelContent>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Clase vehículo:</label>
                                <input 
                                type="text" 
                                class="form-control form-control-sm" 
                                formControlName="bac.clase_vehiculo" 
                                [editable]="false"
                                (focus)="FocusClass$.next($any($event).target.value)"
                                [ngbTypeahead]="SearchClass" 
                                [resultFormatter]="ClassResultFormatter" 
                                [inputFormatter]="ClassInputFormatter" 
                                (ngModelChange)="UpdateCodes()"/>
                            </div>
                        </div>
                        <div class="form-group row" *ngIf="Codes.length">
                            <div class="col-sm">
                                <label>Código clase:</label>
                                <select class="form-control form-control-sm" formControlName="bac.codigo_vehiculo">
                                    <option *ngFor="let Code of Codes" value="{{Code.value}}">{{Code.description}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Número de placa:</label>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="bac.numero_placa"
                                    (change)="CargarRNPrendasVehiculo()">
                                <small class="text-muted">
                                    bac.numero_placa
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Número de placa:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.numero_placa">
                                <small class="text-muted">
                                    rnp.numero_placa
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Identificación propietario:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.identificacion_propietario">
                                <small class="text-muted">
                                    rnp.identificacion_propietario
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Nombre propietario:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.nombre_propietario">
                                <small class="text-muted">
                                    rnp.nombre_propietario
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Marca:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.marca_vehiculo">
                                <small class="text-muted">
                                    rnp.marca_vehiculo
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Estilo:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.estilo">
                                <small class="text-muted">
                                    rnp.estilo
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Categoría:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.categoria">
                                <small class="text-muted">
                                    rnp.categoria
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Capacidad:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.capacidad">
                                <small class="text-muted">
                                    rnp.capacidad
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Serie:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.serie">
                                <small class="text-muted">
                                    rnp.serie
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Chasis:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.chasis">
                                <small class="text-muted">
                                    rnp.chasis
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>VIN:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.vin">
                                <small class="text-muted">
                                    rnp.vin
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Carrocería:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.carroceria">
                                <small class="text-muted">
                                    rnp.carroceria
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Tracción:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.traccion">
                                <small class="text-muted">
                                    rnp.traccion
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Peso Bruto:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.peso_bruto">
                                <small class="text-muted">
                                    rnp.peso_bruto
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Año de fabricación:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.anio_fabricacion">
                                <small class="text-muted">
                                    rnp.anio_fabricacion
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Uso:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.uso">
                                <small class="text-muted">
                                    rnp.uso
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Color:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.color">
                                <small class="text-muted">
                                    rnp.color
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Número de motor:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.numero_motor">
                                <small class="text-muted">
                                    rnp.numero_motor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Marca de Motor:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.marca_motor">
                                <small class="text-muted">
                                    rnp.marca_motor
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Combustible:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.combustible">
                                <small class="text-muted">
                                    rnp.combustible
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cilindrada:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.cilindrada">
                                <small class="text-muted">
                                    rnp.cilindrada
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Potencia:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.potencia">
                                <small class="text-muted">
                                    rnp.potencia
                                </small>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm">
                                <label>Cilindros:</label>
                                <input [readonly]="VerifySupervisorPermission()" type="text" class="form-control form-control-sm"
                                    formControlName="rnp.cilindros">
                                <small class="text-muted">
                                    rnp.cilindros
                                </small>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>
        <div class="col-6">
            <nav>
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <button *ngFor="let TemplateDocument of ActiveTemplateDocuments | keyvalue" class="nav-link"
                        id="nav-{{TemplateDocument.value.Id}}-tab" data-toggle="tab" role="tab"
                        aria-controls="nav-{{TemplateDocument.value.Id}}"
                        [ngClass]="{active:(SelectTab==TemplateDocument.value.DocumentType.Name)}"
                        (click)="SelectTab=TemplateDocument.value.DocumentType.Name">{{TemplateDocument.value.DocumentType.Name}}</button>
                    <div class="d-flex align-items-center">
                        <div class="d-flex justify-content-center"
                            *ngFor="let TemplateDocument of ActiveTemplateDocuments | keyvalue">
                            <button type="button" class="btn btn-sm btn-primary ml-2 btn-light shadow-sm"
                                (click)="Download(TemplateDocument.value)"
                                *ngIf="SelectTab==TemplateDocument.value.DocumentType.Name"
                                [ngClass]="{'disabled':(TemplateDocument.value.AzureLink === '')}"
                                [disabled]="(TemplateDocument.value.AzureLink === '')">Descargar</button>
                            <button class="btn btn-sm btn-primary ml-2 btn-light shadow-sm"
                                (click)="GenerateAndSaveTemplate(TemplateDocument.key)"
                                *ngIf="SelectTab==TemplateDocument.value.DocumentType.Name">Generar y Guardar</button>
                        </div>
                    </div>
                </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
                <div *ngFor="let TemplateDocument of ActiveTemplateDocuments | keyvalue" class="tab-pane fade"
                    [ngClass]="{show: (SelectTab==TemplateDocument.value.DocumentType.Name), active:(SelectTab==TemplateDocument.value.DocumentType.Name)}"
                    id="nav-{{TemplateDocument.value.Id}}" role="tabpanel"
                    aria-labelledby="nav-{{TemplateDocument.value.Id}}-tab">
                    <div class="border border-secondary rounded p-2 mt-3 contrato">
                        <div class="text-justify" 
                            [innerHTML]="ActiveTemplateTexts[TemplateDocument.value.DocumentType.TemplateType.Name.replace(' ','_')+'@'+TemplateDocument.value.DocumentType.Name.replace(' ','_')]">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</block-ui>